import React from 'react';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <>
      <section className="px-5 py-20 text-center md:py-28" data-id="element-83" data-mp="vfpl2cclubxo">
        <h2 className="mx-auto max-w-4xl font-display text-4xl uppercase leading-none text-cream md:text-7xl" data-id="element-84" data-mp="vhaic9qb08z8">
          Votre prochain trimestre peut déjà être <span className="text-gold" data-id="element-85" data-mp="15d3zk6eywqnc">prêt ce soir</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-serif text-lg italic text-cream-muted" data-id="element-86" data-mp="1jd51lp6yy44e">
Le Jazz Master, 5 bonus exclusifs et un système clair pour chaque cours. Pour moins que le prix d’une seule leçon.
        </p>
        <CtaButton className="mt-10" data-id="element-87" data-mp="1t3g55amqqbar" />
      </section>
      <footer className="border-t border-ink-line px-5 pb-28 pt-8 md:pb-8" data-id="element-88" data-mp="1t256tqc2dvr1">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 text-xs text-cream-muted md:flex-row" data-id="element-89" data-mp="1o569kyx3t8om">
          <p data-id="element-90" data-mp="221jp42i2v00g">© 2026 Le Jazz Master. Tous droits réservés.</p>
          <nav aria-label="Liens légaux" className="flex gap-6" data-id="element-91" data-mp="1x5up5y25bh3m">
            <a href="#" className="hover:text-cream" data-id="element-92" data-mp="n5umo42k7rht">Mentions légales</a>
            <a href="#" className="hover:text-cream" data-id="element-93" data-mp="n7ywt3r1xmqj">Confidentialité</a>
            <a href="#" className="hover:text-cream" data-id="element-94" data-mp="s57fr6k0xusu">Contact</a>
          </nav>
        </div>
      </footer>
    </>;
}